import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function More() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-2xl font-semibold">Más</h1>
        <p className="text-muted-foreground">Cotizaciones, rifas, posts, configuración (próximamente)</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Próximamente</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Enlaces a Cotizaciones, Rifas, Posts, Configuración de home, Actividad reciente y Config admin.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
